<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .dropdown-container {
    max-width: utils.in_rem(246px);
  }
</style>

<script>
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import { integrationStore } from "../../../stores";

  export let setting;

  $: items =
    setting?.values?.map((item) => ({
      id: item.val,
      value: item.val,
      label: item.key,
    })) || [];

  $: storeValue = $integrationStore.getValue("notetakerNoteContent");
  $: selected = storeValue;
  $: if (selected !== storeValue) {
    $integrationStore.setValue("notetakerNoteContent", selected);
  }
</script>

<div class="dropdown-container">
  <SingleSelectDropdown bind:selected {items} placeholder="Select one" />
</div>
